import * as React from "react";
import { SVGProps } from "react";

const OkTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M55.4393 29.9323C54.475 28.968 52.8811 28.968 51.9167 29.9323L36.0966 45.7524L29.0827 38.7385C28.1184 37.7742 26.5245 37.7742 25.5601 38.7385C24.5958 39.7028 24.5958 41.2967 25.5601 42.261L34.3353 51.0362C34.8004 51.5012 35.4317 51.7672 36.0966 51.7672C36.7615 51.7672 37.3929 51.5012 37.8579 51.0362L55.4393 33.4548C56.4036 32.4905 56.4036 30.8966 55.4393 29.9323Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M40.5 7C22.0204 7 7 22.0204 7 40.5C7 58.9796 22.0204 74 40.5 74C58.9796 74 74 58.9796 74 40.5C74 22.0204 58.9796 7 40.5 7ZM11.9845 40.5C11.9845 24.7781 24.7781 11.9845 40.5 11.9845C56.2219 11.9845 69.0155 24.7781 69.0155 40.5C69.0155 56.2219 56.2219 69.0155 40.5 69.0155C24.7781 69.0155 11.9845 56.2219 11.9845 40.5Z"
      fill={props.fill || "#1A1C1F"}
    />
  </svg>
);

export default OkTick;
